import { HttpInterceptorFn } from '@angular/common/http';

import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isApiRequest(req.url)) return next(req);
  return next(req.clone({ withCredentials: true }));
};

function isApiRequest(url: string): boolean {
  if (url.startsWith(environment.apiBaseUrl)) return true;
  if (/^https?:\/\//i.test(url)) return false;
  return url.startsWith('/');
}
